import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase'; 
import { collection, addDoc, serverTimestamp, onSnapshot, query, writeBatch, doc, where } from 'firebase/firestore';
import CurrencyInput from '../components/CurrencyInput';
import { logIslem } from '../utils/logger';

function YeniOdeme() {
  const navigate = useNavigate();
  const [cariler, setCariler] = useState([]); 
  
  const [secilenCariId, setSecilenCariId] = useState(''); 
  const [odemeTarihi, setOdemeTarihi] = useState(new Date().toISOString().split('T')[0]); 
  
  // --- SEÇENEK 1: TEK SEFERLİK ---
  const [miktar, setMiktar] = useState(''); 
  const [durum, setDurum] = useState('Bekliyor'); 
  
  // --- SEÇENEK 2: OTOMATİK TAKSİT ---
  const [toplamBorc, setToplamBorc] = useState(''); 
  const [taksitSayisi, setTaksitSayisi] = useState('0'); 
  const [vadeAraligi, setVadeAraligi] = useState('1');

  // --- SEÇENEK 3: MANUEL TAKSİT (YENİ) ---
  const [manuelToplam, setManuelToplam] = useState('');
  const [manuelSayi, setManuelSayi] = useState('0');
  const [manuelPlan, setManuelPlan] = useState([]); // [{tarih: '...', tutar: 100}, ...]

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const taksitOptions = Array.from({ length: 36 }, (_, i) => i + 1);

  // Kural: Bir seçenek doluyken diğerlerini kilitle
  const isOp1Active = miktar !== '';
  const isOp2Active = toplamBorc !== '';
  const isOp3Active = manuelToplam !== '' || manuelPlan.length > 0;

  useEffect(() => {
    const q = query(collection(db, 'cariler'), where("cariTipi", "==", "Tedarikçi"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const carilerList = [];
      querySnapshot.forEach((doc) => { carilerList.push({ id: doc.id, ...doc.data() }); });
      carilerList.sort((a, b) => (a.adSoyad || a.firmaSahis).localeCompare(b.adSoyad || b.firmaSahis));
      setCariler(carilerList); 
    }, (err) => setError("Liste çekilemedi."));
    return () => unsubscribe();
  }, []); 

  // --- MANUEL PLAN OLUŞTURUCU ---
  const planTaslagiOlustur = () => {
    const sayi = parseInt(manuelSayi, 10);
    const toplam = parseFloat(manuelToplam);

    if (sayi <= 0 || isNaN(toplam) || toplam <= 0) {
        alert("Lütfen geçerli bir toplam tutar ve taksit sayısı girin.");
        return;
    }

    const yeniPlan = [];
    const ortalamaTutar = toplam / sayi;
    const baslangic = new Date(odemeTarihi);

    for (let i = 0; i < sayi; i++) {
        const vadeTarihi = new Date(baslangic);
        vadeTarihi.setMonth(baslangic.getMonth() + i); // Varsayılan her ay, sonra elle değişir
        
        yeniPlan.push({
            id: i, // Geçici ID
            tarih: vadeTarihi.toISOString().split('T')[0],
            tutar: ortalamaTutar
        });
    }
    setManuelPlan(yeniPlan);
  };

  // Manuel satır güncelleme
  const updateManuelSatir = (index, field, value) => {
      const yeniListe = [...manuelPlan];
      yeniListe[index][field] = value;
      setManuelPlan(yeniListe);
  };

  // Manuel plandaki toplamı hesapla (Kontrol için)
  const hesaplananToplam = manuelPlan.reduce((acc, item) => acc + (parseFloat(item.tutar) || 0), 0);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!secilenCariId) { setError('Lütfen bir tedarikçi seçin.'); setLoading(false); return; }

    const secilenCari = cariler.find(c => c.id === secilenCariId);
    const cariAdi = secilenCari.adSoyad || secilenCari.firmaSahis; 
    const userEmail = auth.currentUser ? auth.currentUser.email : "Bilinmeyen";
    const batch = writeBatch(db);
    const odemelerRef = collection(db, 'odemeler');

    try {
      // --- SENARYO 1: TEK SEFERLİK ---
      if (isOp1Active) {
         const miktarNum = parseFloat(miktar);
         if(miktarNum <= 0) throw new Error("Geçersiz miktar.");
         
         await addDoc(odemelerRef, {
            cariId: secilenCariId, firmaSahis: cariAdi,
            odemeTarihi: new Date(odemeTarihi), 
            miktar: miktarNum, durum: durum, createdAt: serverTimestamp()
         });
         logIslem("Gider (Tek)", `Kime: ${cariAdi}, Tutar: ${miktarNum}₺`, userEmail, secilenCariId, 'tedarikciler');
      }
      // --- SENARYO 2: OTOMATİK TAKSİT ---
      else if (isOp2Active) {
         const borcNum = parseFloat(toplamBorc);
         const sayi = parseInt(taksitSayisi, 10);
         const aralik = parseInt(vadeAraligi, 10);

         if(borcNum <= 0 || sayi <= 0) throw new Error("Geçersiz otomatik plan.");

         const aylikTutar = borcNum / sayi;
         const baslangic = new Date(odemeTarihi);

         for (let i = 0; i < sayi; i++) {
            const vade = new Date(baslangic);
            vade.setMonth(baslangic.getMonth() + (i * aralik));
            
            const ref = doc(odemelerRef);
            batch.set(ref, {
                cariId: secilenCariId, firmaSahis: cariAdi,
                odemeTarihi: vade, miktar: aylikTutar,
                durum: 'Bekliyor', createdAt: serverTimestamp()
            });
         }
         await batch.commit();
         logIslem("Gider (Oto Taksit)", `Kime: ${cariAdi}, Toplam: ${borcNum}₺, ${sayi} Taksit`, userEmail, secilenCariId, 'tedarikciler');
      }
      // --- SENARYO 3: MANUEL TAKSİT (YENİ) ---
      else if (isOp3Active) {
          if (manuelPlan.length === 0) throw new Error("Lütfen 'Listeyi Oluştur' butonuna basarak planı hazırlayın.");
          
          // Toplam tutar kontrolü (Opsiyonel, uyarı verebiliriz ama kayda engel olmayalım)
          // if (Math.abs(hesaplananToplam - parseFloat(manuelToplam)) > 1) { ... }

          manuelPlan.forEach(satir => {
              const ref = doc(odemelerRef);
              batch.set(ref, {
                  cariId: secilenCariId, firmaSahis: cariAdi,
                  odemeTarihi: new Date(satir.tarih),
                  miktar: parseFloat(satir.tutar),
                  durum: 'Bekliyor', createdAt: serverTimestamp()
              });
          });
          await batch.commit();
          logIslem("Gider (Manuel Taksit)", `Kime: ${cariAdi}, Toplam: ${formatCurrency(hesaplananToplam)}, ${manuelPlan.length} Taksit (Elle Girildi)`, userEmail, secilenCariId, 'tedarikciler');
      } 
      else {
        setError('Lütfen bir ödeme yöntemi seçin ve doldurun.'); setLoading(false); return;
      }

      setLoading(false);
      navigate('/odemeler'); 

    } catch (err) {
      console.error("Hata:", err);
      setError('Hata: ' + err.message);
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1 className="brand-logo admin-brand-header" onClick={() => navigate('/admin/dashboard')} style={{ cursor: 'pointer' }} title="Admin Paneline Dön">
          <img src="/logo.png" width="50" alt="" />
          ARAS ASAF İNŞAAT – YENİ ÖDEME GİRİŞİ
        </h1>
        <button onClick={() => navigate('/odemeler')} className="admin-button-secondary small">İptal / Geri Dön</button>
      </div>

      <form className="yeni-cari-form" onSubmit={handleSubmit}>
        
        {/* GENEL BİLGİLER */}
        <div className="form-section">
          <h2>Gider Bilgileri</h2>
          <div className="form-grid">
            <div className="form-group">
              <label>FİRMA/ŞAHIS (Kime Ödenecek?)</label>
              <select value={secilenCariId} onChange={(e) => setSecilenCariId(e.target.value)}>
                <option value="">Seçiniz...</option>
                {cariler.map(cari => (<option key={cari.id} value={cari.id}>{cari.firmaSahis || cari.adSoyad}</option>))}
              </select>
            </div>
             <div className="form-group"><label>İLK ÖDEME TARİHİ</label><input type="date" value={odemeTarihi} onChange={(e) => setOdemeTarihi(e.target.value)} /></div>
          </div>
        </div>
        
        {/* SEÇENEK 1 */}
        <div className={`form-section ${isOp2Active || isOp3Active ? 'disabled-section' : ''}`} style={{opacity: isOp2Active || isOp3Active ? 0.5 : 1}}>
          <h2>Seçenek 1: Tek Seferlik Gider</h2>
          <div className="form-grid">
            <div className="form-group">
              <label>MİKTAR</label>
              <CurrencyInput value={miktar} onChange={setMiktar} placeholder="1500" disabled={isOp2Active || isOp3Active} style={{ fontWeight: 'bold', color: '#dc3545' }} />
            </div>
            <div className="form-group"><label>DURUM</label><select value={durum} onChange={(e) => setDurum(e.target.value)} disabled={isOp2Active || isOp3Active}><option value="Bekliyor">Bekliyor</option><option value="Ödendi">Ödendi</option></select></div>
          </div>
        </div>

        {/* SEÇENEK 2 */}
        <div className={`form-section ${isOp1Active || isOp3Active ? 'disabled-section' : ''}`} style={{borderLeft: '5px solid #dc3545', opacity: isOp1Active || isOp3Active ? 0.5 : 1}}>
          <h2 style={{color: '#dc3545'}}>Seçenek 2: Otomatik Taksit</h2>
          <div className="form-grid">
            <div className="form-group">
              <label>TOPLAM BORÇ</label>
              <CurrencyInput value={toplamBorc} onChange={setToplamBorc} placeholder="100000" disabled={isOp1Active || isOp3Active} style={{ fontWeight: 'bold' }} />
            </div>
            <div className="form-group"><label>TAKSİT SAYISI</label><select value={taksitSayisi} onChange={(e) => setTaksitSayisi(e.target.value)} disabled={isOp1Active || isOp3Active}><option value="0">Seçiniz</option>{taksitOptions.map(ay => (<option key={ay} value={ay}>{ay} Ay</option>))}</select></div>
            <div className="form-group"><label>ÖDEME SIKLIĞI</label><select value={vadeAraligi} onChange={(e) => setVadeAraligi(e.target.value)} disabled={isOp1Active || isOp3Active}><option value="1">Her Ay</option><option value="2">2 Ayda Bir</option><option value="3">3 Ayda Bir</option><option value="6">6 Ayda Bir</option><option value="12">Yılda Bir</option></select></div>
          </div>
        </div>

        {/* SEÇENEK 3 (YENİ) */}
        <div className={`form-section ${isOp1Active || isOp2Active ? 'disabled-section' : ''}`} style={{borderLeft: '5px solid #ffc107', opacity: isOp1Active || isOp2Active ? 0.5 : 1}}>
            <h2 style={{color: '#d39e00'}}>Seçenek 3: Manuel (Elle) Taksit Planı</h2>
            <p style={{fontSize:'0.9rem', color:'#666'}}>Toplam tutarı ve taksit sayısını girip "Listeyi Oluştur" deyin. Sonra her taksidin tarihini ve tutarını elle düzeltebilirsiniz.</p>
            
            <div className="form-grid" style={{marginBottom:'15px'}}>
                <div className="form-group">
                    <label>TOPLAM TUTAR</label>
                    <CurrencyInput value={manuelToplam} onChange={setManuelToplam} placeholder="300000" disabled={isOp1Active || isOp2Active} style={{fontWeight:'bold'}} />
                </div>
                <div className="form-group">
                    <label>TAKSİT SAYISI</label>
                    <select value={manuelSayi} onChange={(e) => setManuelSayi(e.target.value)} disabled={isOp1Active || isOp2Active}>
                        <option value="0">Seçiniz</option>
                        {taksitOptions.map(ay => (<option key={ay} value={ay}>{ay} Taksit</option>))}
                    </select>
                </div>
                <div className="form-group" style={{justifyContent:'flex-end'}}>
                    <button type="button" onClick={planTaslagiOlustur} className="admin-button-secondary" disabled={isOp1Active || isOp2Active}>📝 Listeyi Oluştur</button>
                </div>
            </div>

            {/* MANUEL TABLO */}
            {manuelPlan.length > 0 && (
                <div style={{background:'#fff8e1', padding:'15px', borderRadius:'8px'}}>
                    <table className="admin-table" style={{marginBottom:'10px'}}>
                        <thead><tr><th>Taksit No</th><th>Vade Tarihi</th><th>Tutar (TL)</th></tr></thead>
                        <tbody>
                            {manuelPlan.map((satir, index) => (
                                <tr key={index}>
                                    <td>{index + 1}. Taksit</td>
                                    <td>
                                        <input 
                                            type="date" 
                                            value={satir.tarih} 
                                            onChange={(e) => updateManuelSatir(index, 'tarih', e.target.value)}
                                            style={{padding:'5px', borderRadius:'4px', border:'1px solid #ccc'}}
                                        />
                                    </td>
                                    <td>
                                        <CurrencyInput 
                                            value={satir.tutar} 
                                            onChange={(val) => updateManuelSatir(index, 'tutar', val)} 
                                            style={{padding:'5px', width:'100%', fontWeight:'bold', color:'#d39e00'}}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{textAlign:'right', fontWeight:'bold', color: Math.abs(hesaplananToplam - parseFloat(manuelToplam)) > 1 ? 'red' : 'green'}}>
                        Girilen Toplam: {formatCurrency(hesaplananToplam)} (Hedef: {formatCurrency(parseFloat(manuelToplam))})
                    </div>
                </div>
            )}
        </div>
        
        {error && <p className="login-error" style={{marginTop: '20px'}}>{error}</p>}
        
        <div className="form-actions">
          <button type="submit" className="admin-button" disabled={loading} style={{ padding: '15px 40px', fontSize: '1.1rem' }}>
            {loading ? 'Kaydediliyor...' : '💾 Gideri Kaydet'}
          </button>
        </div>
      </form>
    </div>
  );
}

// Helper function for displaying summary (can be moved to utils if needed)
function formatCurrency(number) {
    if (typeof number !== 'number') return '0,00 ₺';
    return number.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
}

export default YeniOdeme;